import { useState, useCallback, useEffect } from "react";
import Header from "../../Pages/Header";
import Sidebar from "../../Pages/Sidebar";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import settingsApi from "Services/Settings";

//redux
import { useDispatch } from "react-redux";
import { profiledetails } from "../../Redux/ProfileSettings/actions";

const useStyles = makeStyles((theme) => ({
  shell: {
    position: "fixed",
    inset: 0,
    display: "flex",
    overflow: "hidden",
    fontFamily: "'Plus Jakarta Sans', 'Segoe UI', sans-serif",
    fontSize: 12,
    background: "#F7FAF8",
  },
  sidebarPane: {
    flexShrink: 0,
    height: "100%",
    position: "relative",
    zIndex: 30,
    transition: "width 0.3s ease",
  },
  mainPane: {
    zoom:0.82,
    minWidth: 0,
    minHeight: 0,
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  appBarPane: {
    flexShrink: 0,
    position: "relative",
    zIndex: 20,
  },
  layout: {
    flex: 1,
    minHeight: 0,
    overflow: "auto",
    background: "linear-gradient(180deg, #f9fcff 0%, #f6faff 100%)",
    scrollbarWidth: "thin",
  },
  title: {
    display: "flex",
    gap: 12,
    alignItems: "center",
    padding: "14px 18px 0",
    color: "#172A31",
  },
  pages: {
    minHeight: "100%",
    padding: 50,
  },
}));

const HomeLayout = ({ children, icon, label, noPadding }) => {

  const dispatch = useDispatch();
  const [profileDetails, setProfileDetails] = useState([]);
  const classes = useStyles();

  const sidebarOpen = useSelector((state) => state.sidebar.isOpen);

  //console.log("Sidebar Open State in HomeLayout:", sidebarOpen);
  
    // Get Admin profile details
    const getAdminProfileDetails = useCallback(() => {
      const onSuccess = (res) => {
        if (res?.data?.status === true) {
          setProfileDetails(res?.data?.data);
         // console.log('res?.data?.data-->',res?.data?.data);
          dispatch(profiledetails(res?.data?.data));
        } else {
          setProfileDetails([]);
        }
      };
      const onFailure = (err) => {
        //console.log("get admin profile details api", err);
      };
      settingsApi.getProfileDetails({}).then(onSuccess, onFailure);
    }, [dispatch]);

    useEffect(() => {
        getAdminProfileDetails();
      }, [getAdminProfileDetails]);
    

  return (
    <div className={classes.shell}>
      <aside
        className={classes.sidebarPane}
        style={{ width: sidebarOpen ? 244 : 64 }}
      >
        <Sidebar profileDetails={profileDetails} />
      </aside>

      <main className={classes.mainPane}>
        <div className={classes.appBarPane}>
          <Header profileDetails={profileDetails} />
        </div>

        <section className={classes.layout}>
          {icon && (
            <section className={classes.title}>
              {icon && <section>{icon}</section>}
              <section>
                <Typography sx={{ fontSize: 15, fontWeight: 700 }} variant="body1">
                  {label}
                </Typography>
              </section>
            </section>
          )}

          <div
            className={classes.pages}
            style={
              noPadding
                ? { paddingBlock: 0, paddingInline: 0 }
                : { paddingBlock: 48, paddingInline: 50 }
            }
          >
            {children}
          </div>
        </section>
      </main>
    </div>
  );
};

export default HomeLayout;
